import axiosInstance from "../../config"; // Your Axios config

export const resetPasswordService = async (email) => {
  try {
    const response = await axiosInstance.post("/v1/send-reset-link", { email });

    

    return {
     
      success: true, //return success 
      message: response.data?.message || "Reset link sent successfully",  //return  message
      data: response.data,      //return data response
    };
  } catch (error) {


    return {
      success: false,
      message: error.response?.data?.message || "Failed to send reset link",
      status: error.response?.status || 500,
      errors: error.response?.data?.errors || null,
    };
  }
};
